module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CANADIAN AMERICAN HOCKEY LEAGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Professional hockey was born in Providence when the Providence Reds became inaugural members of the Canadian American Hockey League (CAHL) in 1926–1927. Judge James E. Dooley owned the club, and Jean Dubuc was the team’s general manager. The club played at the Rhode Island Auditorium. Jimmy Gardner was named coach, and the Reds became a farm team of the Montreal Canadiens (NHL). In its 10-year history, the CAHL had a single-division format. Providence finished in last place out of five in 1926–1927 with a 12-17-3 record. Wilfred Desy led the club in goals (10) and points (11) that first season while tying for seventh in goals and tying for eighth in points in CAHL scoring.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In 1927–1928, the Reds finished fifth out of six with a 13-19-8 record and failed to make the postseason again. Johnny Gagnon placed second in goals (20) and tied for third in points (24) in the CAHL, while Armand Mondou placed seventh in league scoring with 21 points.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Providence qualified for the playoffs for the first time in 1928–1929, placing second out of six teams and posting its first winning record—18-12-10. The CAHL playoff format (with the exception of 1931–1932, when the first-place team played the third, and the second-place team played the fourth) had the second and third place teams face off to meet the first place team for the Henri Fontaine Cup (named in honor of the president and owner of the Quebec CAHL franchise who passed away in the middle of the loop’s inaugural season; the trophy was dedicated in his memory). The Reds beat the New Haven Eagles four goals to three in a two-game total goals series to advance to their first finals appearance. The Reds faced the Boston Tigers for the Fontaine Cup championship in a four-game series (two home games each) where total goals would count in case of a tie. Boston won the championship two games to none with two tie games. Art Chapman placed second in the CAHL in points (28) and led the league in assists (14), while Mickey Murray posted a 1.37 GAA and led the CAHL in shutouts (12).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The Reds won their first Fontaine Cup championship in 1929–1930. Providence finished in first place with a 24-11-5 record and was given a direct berth into the finals where they defeated Boston three games to none. Jimmy Gardner began the campaign as coach and was replaced early in the season by Sprague Cleghorn. Reds general manager Jean Dubuc served as interim coach for one game (a loss) prior to Sprague Cleghorn’s arrival. Art Chapman (third place with 45 points), Johnny Gagnon (sixth place with 38 points), and Gizzy Hart (tied for seventh place with 36 points) were among the CAHL scoring leaders. Mickey Murray led the CAHL in wins (23), GAA (2.41), and shutouts (6).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In 1930–1931, Providence secured a third consecutive winning season with a 23-11-6 record and finished in second. Boston, however, defeated Sprague Cleghorn’s team seven goals to six in a two-game total goals series and earned a berth in the finals. Leo Gaudreault (second place with 42 points), Gizzy Hart (tied for third place with 38 points), and Sparky Vail (fifth place with 33 points) were some of the league’s top scorers that season. Mickey Murray led the CAHL in GAA (2.33) and shutouts (4).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Newsy Lalonde became the club’s new coach in 1931–1932, and Providence captured a second Fontaine Cup championship and regular season title (23-11-6 record). The Reds beat the Bronx Tigers in the semifinals five goals to two in a two-game total goals series, and they defeated the Boston Cubs (formerly known as the Tigers) in the finals three games to none. Four Reds placed in the CAHL top 10 in scoring—Gizzy Hart (second place with 38 points), Hago Harrington (third place with 35 points), Leo Gaudreault (tied for seventh place with 28 points), and Leo Murray (tied for seventh place with 28 points). Bill Beveridge led the CAHL in wins (23) and led the team in GAA (2.58).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In 1932–1933, the Reds finished in second place with a 26-16-6 record behind new coach Billy Coutu, who would pilot the team through the 1934–1935 season. Providence lost to Boston in the semifinals seven goals to four in a two-game total goals series. Art Alexandre led the team in points (34), and Leo Murray tallied the most goals (16) for the Reds that season.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Providence captured its third Fontaine Cup championship and third regular season title (19-12-9 record) in 1933–1934. The Reds swept Boston three games to none in the finals. Art Giroux was third in CAHL scoring with 35 points, while Hago Harrington and Leo Gaudreault tied for fifth place in league scoring with 32 points. Paddy Byrne led the team with a 1.91 GAA and eight shutouts.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In 1934–1935, the Reds qualified for the postseason for the seventh straight year and achieved their seventh consecutive winning season with a third place 19-17-12 record. Providence beat the Quebec Castors in the semifinals two games to one but was swept by Boston (now known as the Bruin Cubs) in the finals three games to none. In league scoring, Leo Gaudreault and Hago Harrington tied for fifth place with 49 points, Gerry Lowrey ranked eighth with 44 points, and Gus Rivers ranked ninth with 41 points.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Prior to the 1935–1936 season, Albert “Battleship” Leduc was named player/coach of the team. The Reds responded with a second place finish and a 21-20-6 record. Providence defeated the Springfield Indians two games to one in the semifinals but succumbed in the finals to the Philadelphia Ramblers three games to one. Gus Rivers led the team in points (30) and goals (13).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Providence shares the record for the most Fontaine Cup championships in CAHL history with three (tied with Boston and Springfield). The Reds won the most CAHL regular season titles with three and compiled the best all-time regular season record in the history of the CAHL—198-146-71 (.563).")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0003.jpg",
      "src": "images/e9781439617960_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FONTAINE CUP CHAMPION REDS, 1933-1934.")]), _vm._v(" Pictured here from left to right are Edward Dubuc (trainer), Art Alexandre, Leo Murray, Gizzy Hart, Bob Taylor, Hago Harrington, George Nichols, Art Giroux, Leo Gaudreault, Art Lesieur, Paddy Byrne, Gus Rivers, Andy Mulligan, Jack McVicar, and Billy Coutu (coach).")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "51%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0004.jpg",
      "src": "images/e9781439617960_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ART LESIEUR (DEFENSE).")]), _vm._v(" One of three Reds players with 12 years of service, Lesieur skated on more championship teams with Providence that anyone else, with five (1930, 1932, 1934, 1938, and 1940). In his dozen campaigns with the club (1927–1935 and 1936–1940), he amassed 487 penalties in minutes (PIM), 89 points, and 50 assists in 412 games (10th most in team history). Lesieur played for the Stanley Cup–winning Canadiens (NHL) in 1930–1931.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LEO GAUDREAULT (CENTER/LEFT WING).")]), _vm._v(" He was a member of all three Reds Fontaine Cup championship teams. The forward produced 223 points, 95 goals, and 235 PIM in 307 games during his eight seasons with Providence from 1928 to 1936. Gaudreault spent three years in the NHL between 1927 and 1933 and tallied 12 points and 8 goals in 67 games. He is the CAHL’s all-time leader in assists (128).")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0005.jpg",
      "src": "images/e9781439617960_i0005.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0006.jpg",
      "src": "images/e9781439617960_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ART GIROUX (RIGHT WING).")]), _vm._v(" Giroux was a member of four Reds championship teams: two Fontaine Cups (1931–1932 and 1933–1934) and two Calder Cups (1937–1938 and 1939–1940). He also won a Fontaine Cup with Boston in 1934–1935 and a Teddy Oke Trophy with Detroit of the International Hockey League (IHL) in 1935–1936. In his nine seasons with Providence (1930–1934, 1937–1941, and 1943–1944), Giroux amassed 255 points and 136 goals in 348 games.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0007.jpg",
      "src": "images/e9781439617960_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PROVIDENCE REDS, 1928–1929.")]), _vm._v(" Pictured here from left to right are (first row) Hago Harrington, Wildor Larochelle, Johnny Gagnon, Judge James E. Dooley (owner), Jean Dubuc (general manager), Art Chapman, Archie Wilcox, and Mickey Murray; (second row) Steve Davis (trainer), Roland Paulhus, Art Lesieur, Leo Gaudreault, Gizzy Hart, and Charlie Langlois. The child seated on the ground is Art Chapman Jr. (mascot).")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ART CHAPMAN (CENTER).")]), _vm._v(" Chapman garnered 73 points and 40 goals in 77 games during his two seasons with Providence from 1928 to 1930. He was a member of the Reds’ 1929–1930 Fontaine Cup championship team, and he also won a Fontaine Cup with Springfield in 1927–1928. In 10 NHL campaigns from 1930 to 1940, the center tallied 238 points and 176 assists in 438 games. Chapman coached Buffalo (AHL) to back-to-back Calder Cups in 1942–1943 and 1943–1944.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0008.jpg",
      "src": "images/e9781439617960_i0008.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0009.jpg",
      "src": "images/e9781439617960_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HAROLD “GIZZY” HART (LEFT WING).")]), _vm._v(" He was a member of all three Providence Fontaine Cup championship teams. Hart tallied 164 points, 103 goals, and 159 PIM in 240 games during his six seasons with the Reds from 1928 to 1934. The left-winger played three years in the NHL between 1926 and 1933 and garnered 14 points and 6 goals in 104 games. He was a member of Stanley Cup–winning Victoria in 1924–1925.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0010.jpg",
      "src": "images/e9781439617960_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROLAND PAULHUS (DEFENSE).")]), _vm._v(" A veteran of four seasons with Providence from 1926 to 1930, Paulhus accumulated 264 PIM, 33 points, and 25 goals in 114 games. He skated in 33 games with Montreal (NHL) in 1925–1926. The defenseman also played in the CAHL with New Haven in 1929–1930 and Philadelphia from 1930 to 1932.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROGER CORMIER (RIGHT WING).")]), _vm._v(" Cormier was a member of two Providence Fontaine Cup–winning teams in 1929–1930 and 1931–1932. The right-winger spent six seasons with the Reds from 1926 to 1932, garnering 71 points, 40 goals, and 261 PIM in 216 games. He skated in the IHL for five seasons between 1928 and 1936. The IHL was known as the Canadian Professional Hockey League (CPHL) from 1926 to 1929.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0011.jpg",
      "src": "images/e9781439617960_i0011.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "51%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0012.jpg",
      "src": "images/e9781439617960_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LELAND “HAGO” HARRINGTON (LEFT WING).")]), _vm._v(" Harrington was a member of all three Reds Fontaine Cup championship teams. In his eight years with the club from 1928 to 1936, he had 203 points, 92 goals, and 280 PIM in 299 games. A veteran of three NHL campaigns between 1925 and 1933, the left-winger tallied 12 points and 9 goals in 72 games. Hago is the CAHL’s all-time leader in points (246) and goals (126).")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "36%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0013.jpg",
      "src": "images/e9781439617960_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GERALD CARSON (DEFENSE).")]), _vm._v(" Carson skated for Providence Fontaine Cup championship teams in 1929–1930 and 1931–1932. In three seasons with the Reds from 1929 to 1932, the defenseman totaled 21 points, 14 goals, and 180 PIM in 84 games. A veteran of six NHL campaigns between 1928 and 1937, he produced 23 points, 12 goals, and 205 PIM in 261 games.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ARMAND MONDOU (LEFT WING).")]), _vm._v(" A veteran of 12 NHL seasons from 1928 to 1940, Mondou notched 118 points, 71 assists, and 99 PIM in 386 games. He was a member of the Canadiens’ (NHL) Stanley Cup–winning teams of 1929–1930 and 1930–1931. The left-winger spent five campaigns with Providence (1926–1929, 1932–1933, and 1934–1935) and produced 49 points, 29 goals, and 109 PIM in 106 games.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0014.jpg",
      "src": "images/e9781439617960_i0014.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JIMMY GARDNER (COACH).")]), _vm._v(" Gardner was named the Reds first coach in 1926–1927 and piloted the club until the early part of the 1929–1930 season. He compiled a 46-52-21 (.475) record with Providence. As a player, the left-winger was a member of four Stanley Cup championship teams—the Montreal AAA in 1901–1902 and 1902–1903, and the Montreal Wanderers in 1908–1909 and 1909–1910.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0015.jpg",
      "src": "images/e9781439617960_i0015.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0016.jpg",
      "src": "images/e9781439617960_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MICKEY MURRAY (GOALIE).")]), _vm._v(" Murray has the best all-time GAA (2.01) in Reds’ history for any goalie appearing in over 100 games. He is also tied for first all-time in shutouts (23) in team history. In four campaigns with Providence from 1927 to 1931, the goaltender also had a 70-44-26 record in 140 games. He holds Reds’ single-season records for GAA (1.37 in 1928–1929) and shutouts (12 in 1928–1929).")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0017.jpg",
      "src": "images/e9781439617960_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HARRY CONNOR (LEFT WING).")]), _vm._v(" In his two seasons with the Reds from 1931 to 1933, Connor had 40 points and 20 goals in 66 games. He was a member of Providence’s 1931–1932 Fontaine Cup–winning team. The left-winger produced 21 points, 16 goals, and 149 PIM in 134 NHL games from 1927 to 1931.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ALBERT “BATTLESHIP” LEDUC (DEFENSE/COACH).")]), _vm._v(" Battleship was a member of the Canadiens’ (NHL) first back-to-back Stanley Cup championship teams in 1929–1930 and 1930–1931. In his 10 NHL seasons from 1925 to 1935, the defenseman accumulated 614 PIM and 92 points in 383 games. Leduc was player/coach of the Reds from 1935 to 1937 and tallied 30 points, 23 assists, and 130 PIM in 86 games, while compiling a 42-40-13 (.511) coaching record.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0018.jpg",
      "src": "images/e9781439617960_i0018.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GORDON “DOGGIE” KUHN (RIGHT WING).")]), _vm._v(" He had 131 points, 60 goals, and 164 PIM in 240 games during his five seasons with the Reds from 1934 to 1939. Kuhn was a member of Providence’s 1937–1938 Calder Cup–winning team. The right-winger skated in 12 NHL games and registered two points and one goal.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0019.jpg",
      "src": "images/e9781439617960_i0019.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0020.jpg",
      "src": "images/e9781439617960_i0020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JOHNNY GAGNON (RIGHT WING).")]), _vm._v(" A veteran of 10 NHL seasons from 1930 to 1940, Gagnon produced 261 points, 120 goals, and 295 PIM in 454 games. He won a Stanley Cup with the Canadiens (NHL) in 1930–1931. The right-winger spent five seasons with Providence (1927–1930, 1942–1943, and 1944–1945) and tallied 96 points and 57 goals in 176 games. Gagnon was a member of the Reds’ 1929–1930 Fontaine Cup championship team.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0021.jpg",
      "src": "images/e9781439617960_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ANDY MULLIGAN (DEFENSE).")]), _vm._v(" Mulligan skated for three seasons with the Reds from 1933 to 1936, garnering 33 points, 14 goals, and 144 PIM in 121 games. He was a member of Providence’s 1933–1934 Fontaine Cup–winning team. The defenseman spent 10 seasons in the American Hockey Association (AHA) between 1928 and 1942, and he won a Sinclair Trophy championship with Minneapolis (AHA) in 1936–1937.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JACK MCVICAR (DEFENSE).")]), _vm._v(" He was a member of two Reds’ Fontaine Cup teams in 1929–1930 and 1933–1934. McVicar played three seasons with Providence (1929–1930 and 1932–1934) and tallied 32 points, 18 goals, and 179 PIM in 106 games. The defenseman skated in two NHL seasons from 1930 to 1932 and garnered six points, two goals, and 63 PIM in 88 games.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "39%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0022.jpg",
      "src": "images/e9781439617960_i0022.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BILL BEVERIDGE (GOALIE).")]), _vm._v(" The goaltender had a 2.60 GAA, a 25-16-6 record, and six shutouts in 47 games during three seasons with Providence (1931–1933 and 1938–1939). He was a member of the Reds’ 1931–1932 Fontaine Cup–winning team and led the CAHL in wins with 23 that season. Beveridge spent nine seasons in the NHL between 1929 and 1943, compiling a 2.87 GAA and 18 shutouts in 297 games.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0023.jpg",
      "src": "images/e9781439617960_i0023.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0024.jpg",
      "src": "images/e9781439617960_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MELVILLE “SPARKY” VAIL (DEFENSE/LEFT WING).")]), _vm._v(" Sparky garnered 76 points, 51 assists, and 104 PIM in 115 games during three campaigns with Providence from 1930 to 1933. He was a member of the Reds’ 1931–1932 Fontaine Cup championship team and also won two Fontaine Cups with Springfield (1926–1927 and 1927–1928). In two NHL seasons from 1928 to 1930, he had five points and 18 PIM in 50 games.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0025.jpg",
      "src": "images/e9781439617960_i0025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GUS RIVERS (RIGHT WING).")]), _vm._v(" Rivers won two Stanley Cups with the Canadiens (NHL), in 1929–1930 and 1930–1931, and two Fontaine Cups with Providence, in 1931–1932 and 1933–1934. In six campaigns with the Reds from 1931 to 1937, the right-winger produced 164 points, 72 goals, and 102 PIM in 233 games. A veteran of three NHL seasons from 1929 to 1932, Rivers notched nine points, four goals, and 12 PIM in 88 games.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PADDY BYRNE (GOALIE).")]), _vm._v(" He helped lead the Reds to the 1933–1934 Fontaine Cup championship with a 1.91 GAA, a 19-12-9 record, and eight shutouts. Byrne played five seasons with Providence from 1932 to 1937 and earned a 2.53 GAA in 215 games. He shares the Reds’ all-time team record for shutouts with 23. He spent time in the AHA from 1927 to 1932 and won a Skelly Cup championship with Kansas City")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(AHA) in 1929–1930.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439617960_i0026.jpg",
      "src": "images/e9781439617960_i0026.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45da594c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439617960_c01.vue
// module id = 78
// module chunks = 0